import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is this really chat-native, or just a dashboard with a chatbot bolted on?",
    a: "Chat-native. There's no UI you need to learn — every action (build a brand, draft a campaign, edit budgets, pull reports) happens by chatting with Claude, ChatGPT or Perplexity. The MCP server is the product; the web app is just for billing and connecting accounts.",
  },
  {
    q: "What is MCP?",
    a: "MCP (Model Context Protocol) is an open standard that lets AI clients like Claude, ChatGPT and Perplexity connect to external tools and data. Upfixe runs a remote MCP server that exposes Google Ads campaign creation and management to your AI chat.",
  },
  {
    q: "Do I need a Claude or ChatGPT subscription?",
    a: "You'll need an AI client that supports MCP. Claude (free or paid) and Perplexity work out of the box. ChatGPT supports MCP write access on Business, Enterprise and Edu plans — that's OpenAI's restriction, not ours.",
  },
  {
    q: "Can I target a specific city, region or radius?",
    a: "Yes. Upfixe supports geo targeting below country level — cities, regions, and radius-based targeting all work today. Just describe the area in chat.",
  },
  {
    q: "Does it set up conversion tracking?",
    a: "Not yet. You'll want conversion tracking configured in your own Google Ads / GA4 / GTM setup so Google's Smart Bidding can optimise toward your target CPA. If you don't have it, the campaigns still run — they just won't optimise as quickly. We're working on a guided setup flow.",
  },
  {
    q: "What campaign types does it support?",
    a: "Search campaigns today — the highest-ROI starting point for most small budgets. Performance Max, Display, YouTube and Shopping are on the roadmap. If one of those is a blocker for you, tell us.",
  },
  {
    q: "I run a small agency with a few clients. Does that work?",
    a: "Yes — that's one of the two segments we built this for. Register each client as a separate brand, bind each brand to its own Google Ads sub-account, and switch between them in chat. Multi-brand support is included in the $99/month plan.",
  },
  {
    q: "Is it safe to let AI publish my campaigns?",
    a: "Yes — every campaign is published paused. Nothing spends until you explicitly enable it in the Google Ads UI. Edits to live campaigns require chat confirmation. We also enforce daily spend caps. This is a co-pilot, not autopilot.",
  },
  {
    q: "What if I cancel during the trial?",
    a: "You won't be charged. Your MCP access ends at the end of the trial period and any drafted (but unpublished) campaigns stay in your Google Ads account untouched. After the trial, it's $99/month.",
  },
  {
    q: "Where's my data stored?",
    a: "We store your Google Ads OAuth tokens encrypted in our US-hosted Supabase database (us-west-1). For EU/UK customers, transfers to the US are governed by Standard Contractual Clauses. Chat tool-call logs are kept for 30 days for support and audit. We never share your data with third parties. Full detail in our privacy policy.",
  },
];

const McpFaq = () => {
  return (
    <section className="py-20 px-4 bg-muted/30 border-b border-border">
      <div className="container mx-auto max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-foreground">
          Frequently asked
        </h2>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`item-${i}`}
              className="rounded-lg border border-border bg-background px-5"
            >
              <AccordionTrigger className="text-left font-semibold hover:no-underline">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default McpFaq;
